import PlaylistAdd from '@mui/icons-material/PlaylistAdd';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function PlaylistAddIcon(props: FixMe) {
  return <PlaylistAdd {...props} />;
}

export default PlaylistAddIcon;
